import React, { useRef, useState } from 'react';
import styles from './Table.module.sass';

const Table = ({
    children
}: Props) => {
    const scrollerRef = useRef<any>(null);
    const [scrollPositionX, setScrollPositionX] = useState(0);

    const handleScroll = (event) => setScrollPositionX(event.currentTarget.scrollLeft);

    return <>
        <div className={styles['table__wrapper']}>
            <div
                className={styles['table']}
                ref={scrollerRef}
                onScroll={handleScroll}
            >
                { children }
            </div>
            {
                scrollPositionX >= 32 &&
                <div className={styles['table__indicator--left']} />
            }
            {
                scrollPositionX <= (scrollerRef?.current?.scrollWidth - scrollerRef?.current?.clientWidth - 32) &&
                <div className={styles['table__indicator--right']} />
            }
        </div>
    </>
}

interface Props {
    children: any
}

export default React.memo(Table);